// Native <details> sections shared by Study's Openings/Collections panels.
// Open/closed state lives in a module-level map — remembered across SPA
// re-renders (navigating away and back within the same page load) but reset
// to closed on a real reload, since nothing here touches storage.

import { esc } from "../dom.ts";

const openState = new Map<string, boolean>();

/** A collapsible <details> section, closed by default; remembers its toggle
 *  state (keyed by `key`) for the rest of this page load. */
export function collapsibleSection(key: string, label: string, help: string, count: number): HTMLDetailsElement {
  const details = document.createElement("details");
  details.className = "collapsible-section";
  details.open = openState.get(key) ?? false;
  details.innerHTML = `
    <summary>
      <span><strong>${esc(label)}</strong><small>${esc(help)}</small></span>
      <span class="section-count">${count}</span>
    </summary>
    <div class="section-body"></div>`;
  details.addEventListener("toggle", () => openState.set(key, details.open));
  return details;
}
